<h1 mat-dialog-title >{{ 'LOGISTIC-ORDER/title/delivered-certified-dialog' | translate }}</h1>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="[true]" cdkFocusInitial >{{ 'Confirm' | translate }}</button>
  <button mat-button [mat-dialog-close]="[false]" cdkFocusInitial >{{ 'Cancel' | translate }}</button>
</div>
